module.exports = __webpack_public_path__ + "webfonts/lg.ttf";


//////////////////
// WEBPACK FOOTER
// ../~/lightgallery/src/fonts/lg.ttf?n1z373
// module id = 520
// module chunks = 64 65